import type { UserStore } from './types';

const initialState: UserStore = {
  id: '',
  email: '',
  firstName: null,
  lastName: null,
  profileImagePath: '',
  roles: [],
  emailConfirmed: false,
  isMuted: true,
  createdAt: null,
  subscription: null,
  songDownloadLimit: null,
  stemsDownloadLimit: null,
  samplePackDownloadLimit: null,
  aiGenerationLimit: null,
  submitReleaseLimit: null,
  studioExportLimit: null,
  uploadAudioLimit: null,
  songsLibrary: {
    page: 0,
    songs: {},
    newSongsInLibrary: false,
    songListPosition: 0,
    ids: [],
  },
  subscriptionType: undefined,
  hasDistribution: false,
  artists: [],
};

export default initialState;
